export default "__VITE_ASSET__41365097__"